import { Modal, Form, IFormContext }          from 'rewire-ui';
import DataMutations                          from '../graphql/Mutations';
import { notifications }                      from '../ui/Notifications';
import mainPageModel                          from '../main-navigation/MainPageModel';

export class PostedScheduleDialogModel extends Modal {
  form: Form;

  constructor() {
    super('Post Schedule');
    this.form = Form.create((form: IFormContext) => ({
      postedDate: form.date().label('Posted Date').placeholder('enter posted date').autoFocus(),
    }));
    this.action('cancel')
        .action('save', this.submit, { variant: 'contained', type: 'submit'});
  }

  reset() {
    this.form.reset();
  }

  load() {
    this.reset();
    this.form.value = {
      postedDate: mainPageModel.postedDate,
    };
    this.open();
  }

  private save = async (): Promise<boolean> => {
    const postedDate = this.form.field.postedDate.value;

    const result = await DataMutations.postSchedule(postedDate);

    if (result) {
      notifications.success(`Schedule Successfully Posted Up To: ${postedDate.toDateString()}`);
      mainPageModel.updateLocation();
      return true;
    }

    notifications.error('Post Schedule Failed');
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const postedScheduleDialogModel = new PostedScheduleDialogModel();
export default postedScheduleDialogModel;
